import { render, staticRenderFns } from "./FeedbackInvoices.vue?vue&type=template&id=31b5ad52&"
import script from "./FeedbackInvoices.vue?vue&type=script&lang=ts&"
export * from "./FeedbackInvoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports